// Container Trader: state landing pages (/shipping-containers-for-sale/:state) for the lower 48.
// Bounds (NE lat, NE lng, SW lat, SW lng) come from U.S. Census state extents (same as /p/location).
// Neighbors are used to suggest nearby states when a state has few or no listings.

export const STATE_PAGE_ROUTE = 'StatePage';
export const STATE_PAGE_PATH_PREFIX = '/shipping-containers-for-sale';

const RAW = [
  ['Alabama', 'AL', '35.008,-84.889,30.223,-88.473', 'FL,GA,TN,MS'],
  ['Arizona', 'AZ', '37.004,-109.045,31.332,-114.817', 'CA,NV,UT,CO,NM'],
  ['Arkansas', 'AR', '36.5,-89.644,33.004,-94.618', 'MO,TN,MS,LA,TX,OK'],
  ['California', 'CA', '42.01,-114.131,32.534,-124.41', 'OR,NV,AZ'],
  ['Colorado', 'CO', '41.003,-102.042,36.992,-109.06', 'WY,NE,KS,OK,NM,AZ,UT'],
  ['Connecticut', 'CT', '42.051,-71.787,40.98,-73.728', 'NY,MA,RI'],
  ['Delaware', 'DE', '39.839,-75.049,38.451,-75.789', 'MD,PA,NJ'],
  ['Florida', 'FL', '31.001,-80.031,24.523,-87.635', 'GA,AL'],
  ['Georgia', 'GA', '35.001,-80.84,30.358,-85.605', 'FL,AL,TN,NC,SC'],
  ['Idaho', 'ID', '49.001,-111.044,41.988,-117.243', 'MT,WY,UT,NV,OR,WA'],
  ['Illinois', 'IL', '42.508,-87.495,36.97,-91.513', 'WI,IA,MO,KY,IN'],
  ['Indiana', 'IN', '41.761,-84.785,37.772,-88.098', 'MI,OH,KY,IL'],
  ['Iowa', 'IA', '43.501,-90.14,40.376,-96.64', 'MN,WI,IL,MO,NE,SD'],
  ['Kansas', 'KS', '40.003,-94.588,36.993,-102.052', 'NE,MO,OK,CO'],
  ['Kentucky', 'KY', '39.147,-81.965,36.497,-89.572', 'IN,OH,WV,VA,TN,MO,IL'],
  ['Louisiana', 'LA', '33.019,-88.817,28.929,-94.043', 'TX,AR,MS'],
  ['Maine', 'ME', '47.46,-66.95,42.978,-71.084', 'NH,MA'],
  ['Maryland', 'MD', '39.723,-75.049,37.912,-79.488', 'PA,DE,VA,WV'],
  ['Massachusetts', 'MA', '42.887,-69.928,41.238,-73.508', 'NH,VT,NY,CT,RI'],
  ['Michigan', 'MI', '48.239,-82.413,41.696,-90.418', 'OH,IN,WI'],
  ['Minnesota', 'MN', '49.384,-89.492,43.499,-97.239', 'ND,SD,IA,WI'],
  ['Mississippi', 'MS', '34.996,-88.098,30.174,-91.655', 'TN,AL,LA,AR'],
  ['Missouri', 'MO', '40.614,-89.099,35.996,-95.775', 'IA,IL,KY,TN,AR,OK,KS,NE'],
  ['Montana', 'MT', '49.001,-104.039,44.358,-116.05', 'ND,SD,WY,ID'],
  ['Nebraska', 'NE', '43.002,-95.308,40.0,-104.054', 'SD,IA,MO,KS,CO,WY'],
  ['Nevada', 'NV', '42.002,-114.04,35.002,-120.006', 'OR,ID,UT,AZ,CA'],
  ['New Hampshire', 'NH', '45.305,-70.611,42.697,-72.557', 'ME,VT,MA'],
  ['New Jersey', 'NJ', '41.357,-73.894,38.929,-75.56', 'NY,PA,DE'],
  ['New Mexico', 'NM', '37.0,-103.002,31.332,-109.05', 'CO,OK,TX,AZ,UT'],
  ['New York', 'NY', '45.016,-71.856,40.496,-79.762', 'VT,MA,CT,NJ,PA'],
  ['North Carolina', 'NC', '36.588,-75.461,33.842,-84.322', 'VA,TN,GA,SC'],
  ['North Dakota', 'ND', '49.001,-96.555,45.935,-104.049', 'MN,SD,MT'],
  ['Ohio', 'OH', '41.978,-80.519,38.403,-84.82', 'MI,IN,KY,WV,PA'],
  ['Oklahoma', 'OK', '37.002,-94.431,33.616,-103.003', 'KS,MO,AR,TX,NM,CO'],
  ['Oregon', 'OR', '46.292,-116.464,41.992,-124.566', 'WA,ID,NV,CA'],
  ['Pennsylvania', 'PA', '42.27,-74.69,39.72,-80.52', 'NY,NJ,DE,MD,WV,OH'],
  ['Rhode Island', 'RI', '42.019,-71.121,41.146,-71.863', 'MA,CT'],
  ['South Carolina', 'SC', '35.215,-78.542,32.035,-83.354', 'NC,GA'],
  ['South Dakota', 'SD', '45.945,-96.437,42.48,-104.058', 'ND,MN,IA,NE,WY,MT'],
  ['Tennessee', 'TN', '36.678,-81.647,34.983,-90.31', 'KY,VA,NC,GA,AL,MS,AR,MO'],
  ['Texas', 'TX', '36.501,-93.508,25.837,-106.646', 'NM,OK,AR,LA'],
  ['Utah', 'UT', '42.002,-109.041,36.998,-114.053', 'ID,WY,CO,NM,AZ,NV'],
  ['Vermont', 'VT', '45.017,-71.465,42.727,-73.438', 'NH,MA,NY'],
  ['Virginia', 'VA', '39.466,-75.242,36.541,-83.675', 'MD,WV,KY,TN,NC'],
  ['Washington', 'WA', '49.002,-116.916,45.544,-124.763', 'ID,OR'],
  ['West Virginia', 'WV', '40.639,-77.72,37.201,-82.645', 'OH,PA,MD,VA,KY'],
  ['Wisconsin', 'WI', '47.081,-86.805,42.492,-92.888', 'MI,MN,IA,IL'],
  ['Wyoming', 'WY', '45.006,-104.052,40.995,-111.057', 'MT,SD,NE,CO,UT,ID'],
];

export const toSlug = name => name.toLowerCase().replace(/\s+/g, '-');

export const STATE_PAGES = RAW.map(([name, abbr, bounds, neighbors]) => {
  const [neLat, neLng, swLat, swLng] = bounds.split(',').map(Number);
  return {
    name,
    abbr,
    slug: toSlug(name),
    bounds: { neLat, neLng, swLat, swLng },
    boundsParam: bounds,
    neighbors: neighbors.split(','),
  };
});

export const STATE_BY_SLUG = STATE_PAGES.reduce((acc, s) => ({ ...acc, [s.slug]: s }), {});
export const STATE_BY_ABBR = STATE_PAGES.reduce((acc, s) => ({ ...acc, [s.abbr]: s }), {});

export const statePagePath = state => `${STATE_PAGE_PATH_PREFIX}/${state.slug}`;

// Same address + bounds search the site's location search box uses
export const stateSearchQuery = state =>
  `address=${encodeURIComponent(`${state.name}, USA`)}&bounds=${encodeURIComponent(
    state.boundsParam
  )}`;

const escapeRe = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// True if a listing address belongs to this state.
// Handles "Dallas, TX, USA", "Monroe, UT 84754", "Rhode Island, USA" and "Utah, USA".
// "West Virginia" does not match Virginia and "Arkansas" does not match Kansas.
export const addressInState = (address, state) => {
  if (!address || !state) return false;
  const abbrRe = new RegExp(`(^|,\\s*)${state.abbr}(\\s+\\d{5}(-\\d{4})?)?\\s*(,|$)`);
  const nameRe = new RegExp(`(^|,\\s*)${escapeRe(state.name)}(\\s+\\d{5}(-\\d{4})?)?\\s*(,|$)`);
  return abbrRe.test(address) || nameRe.test(address);
};

// Listing categories that are containers for sale (not transport or wanted ads)
export const CONTAINER_CATEGORIES = [
  '1trip',
  'cw',
  'iicl',
  'wwt',
  'asis',
  'specialty',
  'private',
  'buy-it-now',
  'container-trader-managed-deals',
  'nationwidestatewide',
];

export const CONDITION_LABELS = {
  '1trip': 'One-Trip (new)',
  iicl: 'IICL',
  cw: 'Cargo Worthy',
  wwt: 'Wind & Water Tight',
  asis: 'As-Is',
};

// Sizes are read from the listing title, e.g. "40' High Cube One-Trip Container — Dallas, TX"
export const sizeFromTitle = title => {
  const t = (title || '').replace(/[’′]/g, "'");
  const m = t.match(/\b(10|20|40|45|53)\s*(?:'|ft\b|foot\b)?\s*(HC|High\s*Cube)?/i);
  if (!m) return null;
  const hc = !!m[2] || new RegExp(`\\b${m[1]}\\s*'?\\s*HC\\b`, 'i').test(t);
  if (m[1] === '45' || m[1] === '53') return `${m[1]}' High Cube`;
  return hc ? `${m[1]}' High Cube` : `${m[1]}' Standard`;
};

// City from "Dallas, TX, USA" (not from "Utah, USA" style statewide addresses)
export const cityFromAddress = (address, state) => {
  const parts = (address || '').split(',').map(p => p.trim());
  // Skip a leading street address such as "136 Pilot Rd"
  const first = /^\d/.test(parts[0] || '') ? parts[1] : parts[0];
  if (!first || first === state.name || first === 'United States' || first === 'USA') return null;
  if (/^[A-Z]{2}(\s+\d{5})?$/.test(first)) return null;
  return first;
};
